import { render, staticRenderFns } from "./LocationSalesReport.vue?vue&type=template&id=66dd8c78&scoped=true&"
import script from "./LocationSalesReport.vue?vue&type=script&lang=js&"
export * from "./LocationSalesReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dd8c78",
  null
  
)

export default component.exports